import isAfter from 'date-fns/isAfter';
import addMinutes from 'date-fns/addMinutes';

var useGetValidToken = function useGetValidToken(giid) {
  var localStorageKey = "".concat(giid, "-accessToken");
  var localStorageAccessToken = localStorage.getItem(localStorageKey);
  var validate = function validate(input) {
    if (!input) {
      return null;
    }
    var token = input.token,
      expires = input.expires;
    if (!token || !expires) {
      return null;
    }
    if (isAfter(addMinutes(new Date(), 1), new Date(expires))) {
      localStorage.removeItem(localStorageKey);
      return null;
    }
    return token;
  };
  var validToken = validate(JSON.parse(localStorageAccessToken));
  return {
    validToken: validToken
  };
};

export { useGetValidToken as default };
